export default "__VITE_ASSET__DCo2UmR4__"